export const progressBarDelayMs = 200;
